import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {fetchCourseById} from "../../../service/courses/curses-by/get-curses-by-id/fetchCourseById";
import {BankTransferApiData} from "../../../types/courses/curses-by/get-bank-transfer/getBankTransfer";


interface BankTransferState {
    bankTransfer: BankTransferApiData | null;
    loading: boolean;
    error: string | null;
}

const initialState: BankTransferState = {
    bankTransfer: null,
    loading: false,
    error: null,
};

const getBankTransferSlice = createSlice({
    name: "course",
    initialState,
    reducers: {
        setBankTransfer: (state, action) => {
            state.bankTransfer = action.payload;
            state.loading = false;
            state.error = null;
        },
        setErrorBankTransfer: (state, action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>) => {
            state.error = action.payload.error;

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourseById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCourseById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchCourseById.rejected, (state, action) => {
                state.loading = false;
                // @ts-ignore
                state.error = action.payload;
            });
    },
});

export const { setBankTransfer,setErrorBankTransfer } = getBankTransferSlice.actions;

export const bankTransferReducer = getBankTransferSlice.reducer;
